<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        color="primary"
        v-bind="attrs"
        v-on="on"
        small
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <div class="pa-1">
      <v-tooltip
        right
        color="success"
        v-if="itemType !== 'task'"
      >
        <template v-slot:activator="{ on, attr }">
          <v-btn
            icon
            color="success"
            small
            v-on="on"
            v-bind="attr"
            @click="onNew"
          >
            <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
        </template>
        <span>
          New Folder/Task
        </span>
      </v-tooltip>
      <v-tooltip
        right
        color="primary"
      >
        <template v-slot:activator="{ on, attr }">
          <v-btn
            icon
            color="primary"
            small
            v-on="on"
            v-bind="attr"
            @click="onEdit"
          >
            <v-icon>{{ itemType === 'project' ? 'mdi-cog': 'mdi-pencil-circle' }}</v-icon>
          </v-btn>
        </template>
        <span>
          View Details
        </span>
      </v-tooltip>
      <v-tooltip
        v-if="['task', 'folder'].indexOf(itemType) > -1"
        right
        color="primary"
      >
        <template v-slot:activator="{ on, attr }">
          <v-btn
            icon
            small
            color="primary"
            v-on="on"
            v-bind="attr"
            @click="moveTo()"
          >
            <v-icon>{{ itemType === 'task' ? 'mdi-file-move' : 'mdi-folder-move' }}</v-icon>
          </v-btn>
        </template>
        <span>
          Move To
        </span>
      </v-tooltip>
      <v-tooltip
        v-if="itemType !== 'project'"
        right
        color="red darken-2"
      >
        <template v-slot:activator="{ on, attr }">
          <v-btn
            icon
            color="red darken-2"
            small
            v-on="on"
            v-bind="attr"
            @click="onDelete"
          >
            <v-icon>mdi-delete-circle</v-icon>
          </v-btn>
        </template>
        <span>
          Delete
        </span>
      </v-tooltip>
      <v-tooltip
        v-if="canImportReportsFromJira"
        right
        color="primary"
      >
        <template v-slot:activator="{ on, attr }">
          <v-btn
            icon
            small
            color="primary"
            v-on="on"
            v-bind="attr"
            @click="$emit('onImportFromJiraClick', itemData)"
          >
            <v-icon>mdi-import</v-icon>
          </v-btn>
        </template>
        <span>
          Import reports from Jira
        </span>
      </v-tooltip>
      <v-tooltip
        v-if="itemType === 'project'"
        right
        color="primary"
      >
        <template v-slot:activator="{ on, attr }">
          <v-btn
            icon
            small
            color="primary"
            v-on="on"
            v-bind="attr"
            @click="$emit('onRefresh', itemData.Project_ID)"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>
          Refresh
        </span>
      </v-tooltip>
    </div>
  </v-menu>
</template>
<script>
export default {
  name: 'ConfigDropdown',
  props: {
    itemData: {
      required: true
    }
  },
  computed: {
    projects () {
      return this.$store.getters.getProjects
    },
    canImportReportsFromJira () {
      return this.itemType === 'project' && this.itemData.Is_Integrated
    },
    isIntegrated () {
      return !!(this.itemData.Jira_Task_ID || this.itemData.Jira_Task_Key || this.itemData.Redmine_Issue_ID || this.itemData.Redmine_Issue_Key)
    },
    itemType () {
      return this.itemData.Type.toLowerCase()
    }
  },
  methods: {
    onNew () {
      this.$store.dispatch('showEditTaskOrFolderDialog', {
        show: true,
        data: {
          Assigned_To: null,
          Description: null,
          Estimate: 0,
          Is_Folder: true,
          Name: null,
          Parent_Task_ID: this.itemData.Task_ID || null,
          Project_ID: this.itemData.Project_ID,
          Show_IN_Report: true,
          Reported: 0,
          Start_Date: new Date().toISOString().substring(0, 10),
          Status: 'Open',
          Task_ID: null,
          root_task_id: this.itemData.root_task_id || null
        }
      })
      if (['project', 'folder'].indexOf(this.itemType.toLowerCase()) > -1) {
        this.$emit('onPlusClick', this.itemData)
      }
    },
    async openProjectCard (projectID) {
      if (!this.projects.length) {
        await this.$store.dispatch('setProjects', { projects: null })
      }
      const proj = this.projects.filter(p => p.Project_ID === projectID)[0]
      if (proj) {
        proj.Get_Date = proj.Get_Date ? new Date(proj.Get_Date).toISOString().substr(0, 10) : null
        proj.Start_Date = proj.Start_Date ? new Date(proj.Start_Date).toISOString().substr(0, 10) : null
        proj.Release_Date = proj.Release_Date ? new Date(proj.Release_Date).toISOString().substr(0, 10) : null
        this.$store.dispatch('projectDetailsScreen', {
          show: true,
          project: proj
        })
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Something went wrong!' })
      }
    },
    moveTo () {
      this.$emit('moveTo', this.itemData)
    },
    onEdit () {
      if (this.itemType === 'project') {
        this.openProjectCard(this.itemData.Project_ID)
      } else {
        this.$store.dispatch('showEditTaskOrFolderDialog', {
          show: true,
          data: {
            Assigned_To: this.itemData.Assigned_To,
            Description: this.itemData.Description || null,
            Estimate: this.itemData.Estimate,
            Is_Folder: this.itemData.Is_Folder,
            Name: this.itemData.Name,
            Parent_Task_ID: this.itemData.Parent_Task_ID,
            Project_ID: this.itemData.Project_ID,
            Show_IN_Report: this.itemData.Show_IN_Report,
            Reported: this.itemData.Reported,
            Start_Date: new Date(this.itemData.Start_Date).toISOString().substring(0, 10),
            Status: this.itemData.Status,
            Task_ID: this.itemData.Task_ID,
            root_task_id: this.itemData.root_task_id || null
          }
        })
      }
    },
    onDelete () {
      this.$store.dispatch('setAlertAboutDeleteDialogData', {
        show: true,
        data: {
          Is_Folder: this.itemData.Is_Folder,
          Task_ID: this.itemData.Task_ID,
          Parent_Task_ID: this.itemData.Parent_Task_ID,
          Project_ID: this.itemData.Project_ID,
          Name: this.itemData.Name
        }
      })
    }
  }
}
</script>
